import React, { useEffect, useState } from 'react'
import { Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { useSelector } from 'react-redux'

import { getRosterError } from '../selectors'

// A kiosk is unattended for hours and check-ins are posted straight to the API with
// no offline queue, so a dropped connection currently looks like nothing at all until
// someone taps a name and gets an error.
const useStyles = makeStyles(theme => ({
  banner: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    zIndex: theme.zIndex.modal + 1,
    padding: '12px 16px',
    background: '#D32F2F',
    color: '#FFFFFF',
    textAlign: 'center',
  },
}))

const useIsOnline = () => {
  const [online, setOnline] = useState(() => navigator.onLine !== false)

  useEffect(() => {
    const update = () => setOnline(navigator.onLine !== false)

    window.addEventListener('online', update)
    window.addEventListener('offline', update)
    return () => {
      window.removeEventListener('online', update)
      window.removeEventListener('offline', update)
    }
  }, [])

  return online
}

export default function ConnectionBanner() {
  const classes = useStyles()
  const online = useIsOnline()
  // navigator.onLine only knows about the network interface, so it stays true on a
  // kiosk whose wifi is up but has no route out. A failed roster refresh is what
  // catches that, and it also means the list on screen is no longer trustworthy.
  const rosterError = useSelector(getRosterError)

  if (online && !rosterError) return null

  return (
    <div className={classes.banner} role="alert">
      <Typography variant="subtitle1">
        {online
          ? 'Cannot reach Civic Champs. The volunteer list may be out of date.'
          : 'No internet connection. Check-ins cannot be saved until it is back.'}
      </Typography>
    </div>
  )
}
